import { z } from "zod";

import { Codelist } from "@/data/codelists";

export const TimeReportStage = z.union([
  z.literal("APPROVED"),
  z.literal("DRAFT"),
  z.literal("IN_APPROVAL"),
  z.literal("REJECTED"),
  z.literal("REVISED"),
  z.literal("UPDATED"),
]);

export type TimeReportStage = z.infer<typeof TimeReportStage>;

export const TimeReportStageCodelist = Codelist<TimeReportStage>(TimeReportStage);

export type TimeReportStageCodelist = z.infer<typeof TimeReportStageCodelist>;
